export default __webpack_public_path__ + "c81f5f20ae0974313db5d2de4b0bca7f.png";